import { render, staticRenderFns } from "./TransactionHistoryPivot.vue?vue&type=template&id=00b04df3&scoped=true"
import script from "./TransactionHistoryPivot.vue?vue&type=script&lang=js"
export * from "./TransactionHistoryPivot.vue?vue&type=script&lang=js"
import style0 from "./TransactionHistoryPivot.vue?vue&type=style&index=0&id=00b04df3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b04df3",
  null
  
)

export default component.exports